import { Provider as ReduxProvider } from 'react-redux';

import Config from '@/components/Config';
import Toast from '@/components/Toast';

import Router from './Router';
import store from './store';

function App() {
	return (
		<ReduxProvider store={store}>
			<Config />
			<Router />
			<Toast />
		</ReduxProvider>
	);
}

export default App;
